import {
  Button,
  DatePicker,
  Divider,
  Dropdown,
  Flex,
  Space,
  Table,
} from "antd";
import React, { useEffect, useState } from "react";
import api from "../../api";
import { IconArrowRight, IconSearch } from "@tabler/icons-react";
import { formatCurrency, formatDateTime } from "../../utilities/utils";
import CustomHeader from "../../components/header/CustomHeader";
import CustomModal from "../../components/modal/CustomModal";
import CustomInput from "../../components/input/CustomInput";
import CustomTextarea from "../../components/input/CustomTextarea";
import { useToast } from "../../components/toast/toast";
import TicketDetailDrawer from "./TicketDetailDrawer";

const { RangePicker } = DatePicker;

const Ticket = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [phone, setPhone] = useState("");
  const [prefix, setPrefix] = useState("");
  const [bankNumber, setBankNumber] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [dateRange, setDateRange] = useState([null, null]);
  const [showModal, setShowModal] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    phone: "",
    ticket_code: "",
    type: "TICKET",
  });
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [showDrawer, setShowDrawer] = useState(false);
  const toast = useToast();

  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const clearHandler = () => {
    setShowModal(false);
    setFormData({
      title: "",
      description: "",
      phone: "",
      ticket_code: "",
      type: "TICKET",
    });
  };

  const fetchTickets = async (
    paramsFromClear = null,
    page = 1,
    pageSize = 10,
  ) => {
    setLoading(true);
    const params = paramsFromClear ?? {
      ...(phone && { phone_number: phone }),
      ...(prefix && { ticket_prefix: prefix }),
      ...(bankNumber && { bank_number: bankNumber }),
      ...(transactionId && { transaction_id: transactionId }),
      // date filter:
      ...(dateRange?.[0] && dateRange?.[1]
        ? {
            from_date: dateRange[0].format("YYYY-MM-DD"),
            to_date: dateRange[1].format("YYYY-MM-DD"),
          }
        : {}),
    };

    // console.log("fetching with params:", params);
    const res = await api.get_ticket_list({
      ...params,
      page,
      limit: pageSize,
    });

    // console.log("tickets res --->", res);
    if (res.status === 200) {
      setTickets(res.data.data);
      setPagination((prev) => ({
        ...prev,
        current: page,
        pageSize,
        total: res.data.total || 0,
      }));
    } else {
      // console.error("Error fetching tickets:", res);
      toast(res.data?.message || "Алдаа гарлаа", "error");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (pagination) {
      fetchTickets(null, pagination.current, pagination.pageSize);
    }
  }, []);

  const columns = [
    {
      title: "№",
      key: "index",
      render: (_, __, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
      width: 60,
    },
    {
      title: "Утасны дугаар",
      dataIndex: "phone_number",
      key: "phone_number",
    },
    {
      title: "Төлөв",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color = "";
        let label = "";

        switch (status) {
          case "canceled":
            color = "red";
            label = "Цуцлагдсан";
            break;
          case "paid":
            color = "#0066cc";
            label = "Төлсөн";
            break;
          case "pending":
            color = "orange";
            label = "Хүлээгдэж байна";
            break;
          default:
            color = "gray";
            label = status;
        }

        return <span style={{ color, fontWeight: 500 }}>{label}</span>;
      },
    },

    // {
    //   title: "Сугалааны нэр",
    //   dataIndex: ["Lottery", "title"],
    //   key: "lottery_title",
    // },
    {
      title: "Сугалааны код",
      dataIndex: ["Lottery", "ticket_prefix"],
      key: "ticket_prefix",
    },
    {
      title: "Үнийн дүн",
      key: "amount",
      render: (_, record) => {
        const firstPayment = record.Payments?.[0]?.amount;
        const invoiceAmount = record.Invoice?.amount;
        const val = firstPayment ?? invoiceAmount ?? 0;
        return formatCurrency(Number(val));
      },
    },
    {
      title: "Сугалаа авсан огноо",
      dataIndex: "created_at",
      key: "created_at",
      render: (val) => formatDateTime(val) || "",
    },
    // {
    //   title: "Сугалаа авсан огноо",
    //   dataIndex: "updated_at",
    //   key: "updated_at",
    //   render: (val) => formatDateTime(val) || "",
    // },
    {
      title: "Үйлдэл",
      key: "actions",
      width: 150,
      render: (_, record) => {
        const items = (record) => [
          {
            key: "detail",
            label: (
              <span style={{ color: "black", fontSize: "13px" }}>
                Дэлгэрэнгүй
              </span>
            ),
            // onClick: () => handleView(record.id),
          },
          // {
          //   key: "delete",
          //   label: (
          //     <span style={{ color: "red", fontSize: "13px" }}>Устгах</span>
          //   ),
          //   // onClick: () => handleDelete(record.id),
          // },
        ];

        return (
          <Dropdown
            menu={{
              items: items(record),
              onClick: ({ key }) => {
                if (key === "delete") {
                  // console.log("Устгах:", record);
                } else if (key === "detail") {
                  // console.log("detail", record);
                  setSelectedRecord(record);
                  setShowDrawer(true);
                }
              },
            }}
            trigger={["click"]}
          >
            <Button
              variant="filled"
              color="default"
              style={{ padding: "0 20px", fontSize: "12px" }}
            >
              Үйлдэл
              <IconArrowRight size={12} />
            </Button>
          </Dropdown>
        );
      },
    },
  ];

  const submitHandler = async () => {
    if (formData.title && formData.description) {
      const res = await api.create_complaint(formData);
      // console.log("create complaint res --->", res);

      if (res.status === 201) {
        clearHandler();
        toast("Амжилттай үүслээ.", "success");
      } else {
        toast(res.data.message || "Алдаа гарлаа", "error");
      }
    }
  };

  return (
    <div>
      <CustomHeader
        title={"Хэрэглэгчийн оролцоо"}
        // rightSide={
        //   <Button
        //     variant="dashed"
        //     color="danger"
        //     size="large"
        //     style={{ padding: "0px 20px" }}
        //     onClick={() => setShowModal(true)}
        //   >
        //     <IconPlus size={16} />
        //     Гомдол, Асуудал үүсгэх
        //   </Button>
        // }
      />
      {/* <Divider style={{ marginBottom: "20px" }} /> */}
      <Space style={{ marginBottom: 16 }}>
        <CustomInput
          placeholder="Утасны дугаар"
          value={phone}
          // onChange={(e) => setPhone(e.target.value)}
          onChange={(e) => {
            const onlyNums = e.target.value.replace(/\D/g, "");
            if (onlyNums.length <= 8) setPhone(onlyNums);
          }}
          style={{ width: 200 }}
          maxLength={8}
          type="number"
        />
        <CustomInput
          placeholder="Сугалааны код (AZ51...)"
          value={prefix}
          onChange={(e) => setPrefix(e.target.value)}
          style={{ width: 200 }}
        />
        <CustomInput
          placeholder="Дансны дугаар"
          value={bankNumber}
          onChange={(e) => setBankNumber(e.target.value)}
          style={{ width: 200 }}
        />
        <RangePicker
          placeholder={["Эхлэх огноо", "Дуусах огноо"]}
          value={dateRange}
          onChange={(vals) => {
            setDateRange(vals || [null, null]);
          }}
          style={{ width: 260, minHeight: "40px" }}
          allowClear
        />

        <CustomInput
          placeholder="ID ..."
          value={transactionId}
          onChange={(e) => setTransactionId(e.target.value)}
          style={{ width: 220 }}
        />
        <Button
          size="large"
          icon={<IconSearch size={14} />}
          // onClick={() => fetchTickets()}
          onClick={() => fetchTickets(null, 1, pagination.pageSize)}
        >
          Хайх
        </Button>
        <Divider type="vertical" />
        <Button
          size="large"
          onClick={() => {
            setPhone("");
            setPrefix("");
            setBankNumber("");
            setDateRange([null, null]);
            setTransactionId("");
            fetchTickets({});
          }}
        >
          Цэвэрлэх
        </Button>
      </Space>

      <Table
        dataSource={tickets}
        columns={columns}
        rowKey="id"
        loading={loading}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
        }}
        onChange={(pagination) => {
          fetchTickets(null, pagination.current, pagination.pageSize);
        }}
      />

      <CustomModal
        title={"Гомдол, Асуудал үүсгэх"}
        width={450}
        open={showModal}
        onOk={submitHandler}
        onCancel={() => clearHandler()}
        disabled={!formData.title || !formData.description}
      >
        <Flex vertical gap={"10px"}>
          <CustomInput
            title={"Гарчиг"}
            required
            value={formData.title}
            onChange={(e) => handleChange("title", e.target.value)}
          />

          <CustomTextarea
            required
            title={"Дэлгэрэнгүй"}
            value={formData.description}
            onChange={(e) => handleChange("description", e.target.value)}
            maxLength={200}
          />

          <CustomInput
            title={"Утасны дугаар"}
            value={formData.phone}
            onChange={(e) => {
              const onlyNums = e.target.value.replace(/\D/g, "");
              if (onlyNums.length <= 8) {
                handleChange("phone", onlyNums);
              }
            }}
          />

          <CustomInput
            title={"Сугалааны код, тасалбарын дугаар"}
            value={formData.ticket_code}
            onChange={(e) => handleChange("ticket_code", e.target.value)}
          />
        </Flex>
      </CustomModal>

      {/* -------------------- DETAIL DRAWER ----------------------- */}
      <TicketDetailDrawer
        open={showDrawer}
        onClose={() => {
          setShowDrawer(false);
          setSelectedRecord(null);
        }}
        record={selectedRecord}
      />
    </div>
  );
};

export default Ticket;
